import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";

export default function HematologicalTestForm({ defaultValues, onSubmit }) {
  const { register, handleSubmit } = useForm({ defaultValues: defaultValues || {} });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="WBC" size="small" variant="outlined" name="wbc" type="number" {...register('wbc')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Neutrophil" size="small" variant="outlined" name="neutrophil" type="number" {...register('neutrophil')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Lymphocyte" size="small" variant="outlined" name="lymphocyte" type="number" {...register('lymphocyte')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Monocyte" size="small" variant="outlined" name="monocyte" type="number" {...register('monocyte')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Basophil" size="small" variant="outlined" name="basophil" type="number" {...register('basophil')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="ESR" size="small" variant="outlined" name="esr" type="number" {...register('esr')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Platelet" size="small" variant="outlined" name="platelet" type="number" {...register('platelet')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Blood Group" size="small" variant="outlined" name="bloodGroup" {...register('bloodGroup')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="HB" size="small" variant="outlined" name="hb" type="number" {...register('hb')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="RBC" size="small" variant="outlined" name="rbc" type="number" {...register('rbc')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="PCV" size="small" variant="outlined" name="pcv" type="number" {...register('pcv')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
      </Grid>
      <Box mt={2}>
        <Button type="submit" variant="contained" color="primary" size="small">सुरक्षित गर्नुहोस्</Button>
      </Box>
    </form>
  );
}
